<template>
  <div
    class="dropdown"
    style="float: left; padding: 13px; font-size:1.5rem;">
    <a
      id="dropdownMenu1"
      role="button"
      data-toggle="dropdown"
      data-target="#"
      style="float: left"
      aria-expanded="true"
      @click="toggleMenu">
    <fa :icon="['fa', 'bell']"/></a>
    <span 
      v-if="notificationCount !== 0" 
      class="badge badge-danger badge-circle">{{ notificationCount }}</span>
    <ul
      v-if="active && notificationCount !== 0"
      class="dropdown-menu notification-dropdown"
      style="display: block !important;">
      <li
        style="background-color: #fff; max-height: 350px; overflow: auto">
        <p 
          v-for="(item, i) in notification"
          :key="i"
          :class="isReadClass(item)">
          <router-link
            v-if="item.entity_id === 1"
            :to="{ name: 'Insights page'}"
            class="insight-page-button"
            @click.native="updateStatusNotification(item)">
            {{ item.title }}
          </router-link>
          <a 
            v-else 
            style="cursor: pointer" 
            @click="showInsightRateModal(item)">
            {{ item.title }}
          </a>
          <span class="timeline-icon"><i
            class="fa fa-file-pdf-o"/></span><br>
          <span>{{ item.created_at }}</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import InsightRateModal from "./modals/InsightRate/InsightRateModal";
import profileMixin from "@/mixins/profileMixin";

export default {
  components: {InsightRateModal},
  mixins: [profileMixin],
  data: () => ({
    active: false,
    params: {},
  }),
  computed: {
    ...mapGetters(['user']),

    notification() {
      return this.user.notifications.map((val) => {
        return {
          'id': val.id,
          'title': val.title,
          'is_read': val.is_read,
          'entity_id': val.entity_id,
          'type_id': val.type_id,
          'created_at': moment(val.created_at).format('LLL'),
        }
      }).reverse()
    },

    notificationCount(){
      return this.user.notifications.filter((val) => {
        return val.is_read === 0
      }).length
    },


  },

  beforeDestroy () {
    document.removeEventListener('click',this.close)
  },

  methods: {
    ...mapActions(['updateNotifications']),

    toggleMenu(){
      this.active = !this.active;
    },

    updateStatusNotification(item){
      this.params['notificationId'] = item.id;
      this.updateNotifications(this.params)
    },

    isReadClass(item) {
      return item.is_read === 0 ? 'not_read' : 'hide'
    },

    showInsightRateModal(item) {
        this.params['notificationId'] = item.id;
        this.updateNotifications(this.params)
        this.showModal('showInsightRateModal', item)
        this.active = !this.active;
    }
  },
}
</script>

<style lang="scss">

.notification-dropdown {
  padding: 15px!important;
  width: 300px;
  margin-left: -200px;

  span {
    font-size: small;
    color: #8d888a;
  }

  a {
    padding: 0!important;
    font-size: large;
    color: #6e3f80!important;
  }
}

.not_read {
  font-weight:bold;
  color: #6e3f80!important;
}

.hide {
    display: none !important;
}

.notification-dropdown a{
  font-size: large;
  color: #6e3f80!important;
}


/* -----------------------------------------
   Timeline
----------------------------------------- */
.timeline {
  list-style: none;
  padding-left: 0;
  position: relative;
}
.timeline:after {
  content: "";
  height: auto;
  width: 1px;
  background: #e3e3e3;
  position: absolute;
  top: 5px;
  left: 30px;
  bottom: 25px;
}
.timeline.timeline-sm:after {
  left: 12px;
}
.timeline li {
  position: relative;
  padding-left: 70px;
  margin-bottom: 20px;
}
.timeline li:after {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e3e3e3;
  position: absolute;
  left: 24px;
  top: 5px;
}
.timeline li .timeline-date {
  display: inline-block;
  width: 100%;
  color: #a6a6a6;
  font-style: italic;
  font-size: 13px;
}
.timeline.timeline-icons li {
  padding-top: 7px;
}
.timeline.timeline-icons li:after {
  width: 32px;
  height: 32px;
  background: #fff;
  border: 1px solid #e3e3e3;
  left: 14px;
  top: 0;
  z-index: 11;
}
.timeline.timeline-icons li .timeline-icon {
  position: absolute;
  left: 23.5px;
  top: 7px;
  z-index: 12;
}
.timeline.timeline-icons li .timeline-icon [class*=glyphicon] {
  top: -1px !important;
}
.timeline.timeline-icons.timeline-sm li {
  padding-left: 40px;
  margin-bottom: 10px;
}
.timeline.timeline-icons.timeline-sm li:after {
  left: -5px;
}
.timeline.timeline-icons.timeline-sm li .timeline-icon {
  left: 4.5px;
}
.timeline.timeline-advanced li {
  padding-top: 0;
}
.timeline.timeline-advanced li:after {
  background: #fff;
  border: 1px solid #29b6d8;
}
.timeline.timeline-advanced li:before {
  content: "";
  width: 52px;
  height: 52px;
  border: 10px solid #fff;
  position: absolute;
  left: 4px;
  top: -10px;
  border-radius: 50%;
  z-index: 12;
}
.timeline.timeline-advanced li .timeline-icon {
  color: #29b6d8;
}
.timeline.timeline-advanced li .timeline-date {
  width: 75px;
  position: absolute;
  right: 5px;
  top: 3px;
  text-align: right;
}
.timeline.timeline-advanced li .timeline-title {
  font-size: 17px;
  margin-bottom: 0;
  padding-top: 5px;
  font-weight: bold;
}
.timeline.timeline-advanced li .timeline-subtitle {
  display: inline-block;
  width: 100%;
  color: #a6a6a6;
}
.timeline.timeline-advanced li .timeline-content {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-right: 70px;
}
.timeline.timeline-advanced li .timeline-content p {
  margin-bottom: 3px;
}
.timeline.timeline-advanced li .timeline-content .divider-dashed {
  padding-top: 0px;
  margin-bottom: 7px;
  width: 200px;
}
.timeline.timeline-advanced li .timeline-user {
  display: inline-block;
  width: 100%;
  margin-bottom: 10px;
}
.timeline.timeline-advanced li .timeline-user:before,
.timeline.timeline-advanced li .timeline-user:after {
  content: " ";
  display: table;
}
.timeline.timeline-advanced li .timeline-user:after {
  clear: both;
}
.timeline.timeline-advanced li .timeline-user .timeline-avatar {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  float: left;
  margin-right: 10px;
}
.timeline.timeline-advanced li .timeline-user .timeline-user-name {
  font-weight: bold;
  margin-bottom: 0;
}
.timeline.timeline-advanced li .timeline-user .timeline-user-subtitle {
  color: #a6a6a6;
  margin-top: -4px;
  margin-bottom: 0;
}
.timeline.timeline-advanced li .timeline-link {
  margin-left: 5px;
  display: inline-block;
}
.timeline-load-more-btn {
  margin-left: 70px;
}
.timeline-load-more-btn i {
  margin-right: 5px;
}


/* -----------------------------------------
   Dropdown
----------------------------------------- */
.dropdown-menu{
  padding:0 0 0 0;
}
a.dropdown-menu-header {
  background: #f7f9fe;
  font-weight: bold;
  border-bottom: 1px solid #e3e3e3;
}
.dropdown-menu > li a {
  padding: 10px 20px;
}



</style>


// WEBPACK FOOTER //
// src/components/Notification.vue